import { useState, useEffect } from "react";
import { useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import { CommonListType } from "../../../hooks/useCommonList/useCommonListWrap";
import { PriceDetail } from "../../../../models/Order";
import { getListOrder, getListOrderAdmin, getListOrderPartner } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { CommonParamsType } from "../../../hooks/useCommonList/commonHelper";
import { PERPAGE } from "../../Partner/PartnerManagement";

export interface AdminOrderParams extends CommonParamsType {
	filterStaffId?: string | null;
	filterStatusString?: string | null;
}

export function AdminOrderExtractor(filter: CommonParamsType, uParams: URLSearchParams) {
	return {
		...filter,
		filterStaffId: uParams.get("filterStaffId") || undefined,
		filterStatusString: uParams.get("filterStatusString") || undefined,
	};
}

export function AdminOrderExtraParams(filter: AdminOrderParams) {
	return {
		...(filter.filterStaffId && { filterStaffId: filter.filterStaffId }),
		...(filter.filterStatusString && { filterStatusString: filter.filterStatusString }),
	};
}

export default function useListOrder(props?: CommonListType, prop?: { user?: User | null }) {
	const [listOrder, setListOrder] = useState<PriceDetail[]>([]);
	const [count, setCount] = useState(0);
	const [countPages, setCountPages] = useState(0);
	const loadListOrder = async (
		inPage: number,
		inPerPage: number,
		status?: string[],
		fromDate?: Date | undefined,
		toDate?: Date | undefined,
		store?: string,
		userId?: number,
		fromReplyDate?: Date | undefined,
		toReplyDate?: Date | undefined,
		country?: string,
		provice?: string,
		id?: string,
		stationActive?: string,
	) => {
		props?.onBeginLoad?.();
		try {
			const startOfDayFromDate = fromDate ? new Date(new Date(fromDate).setHours(0, 0, 0, 0)) : undefined;
			const endOfDayToDate = toDate ? new Date(new Date(toDate).setHours(23, 59, 59, 999)) : undefined;
			const startOfDayReplyFromDate = fromReplyDate ? new Date(new Date(fromReplyDate).setHours(0, 0, 0, 0)) : undefined;
			const endOfDayToReplyDate = toReplyDate ? new Date(new Date(toReplyDate).setHours(23, 59, 59, 999)) : undefined;
			const res =
				prop?.user?.role === UserRole.Partner
					? await getListOrderPartner(inPage, inPerPage)
					: prop?.user?.role === UserRole.Admin
					? await getListOrderAdmin(
							inPage,
							inPerPage,
							status,
							startOfDayFromDate,
							endOfDayToDate,
							store,
							userId,
							startOfDayReplyFromDate,
							endOfDayToReplyDate,
							country,
							provice,
							id,
							stationActive,
					  )
					: await getListOrder(inPage, inPerPage);

			const data = res.data;
			setListOrder(data);
			setCount(res.count);
			setCountPages(res.numberPage)
		} catch {
			setListOrder([]);
		} finally {
			props?.onEndLoad?.();
		}
	};
	const reload = () => {
		loadListOrder(
			props?.page || 1,
			props?.perPage || 0,
			props?.filterStates?.split(";") || undefined,
			props?.filterFromDate || undefined,
			props?.filterToDate || undefined,
			props?.filterStore || undefined,
			props?.filterUserId || undefined,
			props?.filterFromReplyDate || undefined,
			props?.filterToReplyDate || undefined,
			props?.filterCountry || undefined,
			props?.filterProvice || undefined,
			props?.filterKeyword || undefined,
			props?.filterActive || undefined,
		);
	};
	useEffect(() => {
		reload();
	}, [
		props?.page,
		props?.perPage,
		props?.filterStates,
		props?.filterFromDate,
		props?.filterToDate,
		props?.filterStore,
		props?.filterUserId,
		props?.filterFromReplyDate,
		props?.filterToReplyDate,
		props?.filterCountry,
		props?.filterProvice,
		props?.filterKeyword,
		props?.filterActive,
	]);
	return {
		listOrder,
		reload,
		count,
		countPages
	};
}

export const getUseListOrder = (prop: { user?: User | null }) => {
	const hookResult = (props: CommonListType) => useListOrder(props, prop);
	return useCommonListWrap(PERPAGE.PerPage, hookResult);
};
